export default {"src":"/_next/static/media/direct-download-badge.c474ca43.svg","height":54,"width":180};